import React from 'react';

interface BridgeScreen3DIconProps {
  size?: number;
  color?: string;
}

export const BridgeScreen3DIcon = ({ size = 48, color = '#BC1A6C' }: BridgeScreen3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 30);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="22" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Left pillar */}
      <rect x="4" y="16" width="8" height="40" rx="1" fill={color} />
      <path d="M12 16 L14 14 L14 54 L12 56 Z" fill={darkerColor} />
      {/* Right pillar */}
      <rect x="52" y="16" width="8" height="40" rx="1" fill={color} />
      <path d="M60 16 L62 14 L62 54 L60 56 Z" fill={darkerColor} />
      {/* Bridge arch top */}
      <path d="M12 16 L32 6 L52 16 L52 20 L32 10 L12 20 Z" fill={color} />
      <path d="M52 16 L54 14 L34 4 L32 6 Z" fill={darkerColor} />
      <path d="M52 20 L54 18 L54 14 L52 16 Z" fill={darkerColor} />
      {/* Bridge deck */}
      <rect x="4" y="28" width="56" height="4" rx="1" fill={lighterColor} />
      <rect x="4" y="30" width="56" height="4" rx="1" fill={color} />
      {/* Screen panel hanging under bridge */}
      <rect x="16" y="34" width="32" height="16" rx="2" fill={color} />
      <path d="M48 34 L50 32 L50 48 L48 50 Z" fill={darkerColor} />
      <path d="M16 34 L18 32 L50 32 L48 34 Z" fill={lighterColor} />
      {/* Screen inner glow */}
      <rect x="19" y="37" width="26" height="10" rx="1" fill="white" opacity="0.25" />
      {/* Play icon on screen */}
      <polygon points="29,39 29,45 35,42" fill="white" opacity="0.5" />
      {/* Shine */}
      <rect x="16" y="34" width="32" height="3" rx="1" fill="white" opacity="0.12" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
